import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { BreadCrumbs, IntlMessages } from '@/components';
import useNavigationSource from '../../../../../app/hooks/useNavigationSource';
import FormImportDictionaries from '../../../forms/FormImportDictionaries';
import { useImportDictionariesMutation } from '../../../api/dictionariesApiSlice';
import appRoutes from '@/configs/routes';
import getFeatureSourceTranslation from '../../../../Featured/utils/getFeatureSourceTranslation';
import handleResponse from '../../../../../lib/handleResponse';

const { Title } = Typography;

const PageDictionariesImport = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [searchQueryParams] = useSearchParams();
  const { urlPrefix, navigationSource } = useNavigationSource();

  const multipleSources = searchQueryParams.get('multipleSources') ?? null;

  const [importDictionaries, { isLoading: isImportingDictionaries }] = useImportDictionariesMutation();

  const onImportDictionaries = async (values) => {
    const formData = new FormData();

    formData.append('file', values.file);
    formData.append('source', multipleSources ? null : navigationSource);

    importDictionaries({ formData })
      .unwrap()
      .then((data) => {
        navigate(appRoutes.urlPageDictionariesImportSuccess({ urlPrefix, source: navigationSource, multipleSources }), {
          state: { dictionaries: data ?? [] },
        });
      })
      .catch((error) => handleResponse('error', intl, 'dictionaries-import-failed', [], error));
  };

  return (
    <>
      <Row gutter={[32, 32]} justify="space-between" className="hp-mb-12" align="middle">
        <BreadCrumbs
          breadCrumbParent={
            urlPrefix ? (
              <Link to={appRoutes.urlPageFeatures({ featureSource: urlPrefix, multipleSources })}>
                <IntlMessages id={getFeatureSourceTranslation(urlPrefix)} />
              </Link>
            ) : null
          }
          breadCrumbParent2={
            <Link to={appRoutes.urlPageDictionaries({ urlPrefix, source: navigationSource, multipleSources })}>
              <IntlMessages id="dictionaries-breadcrumbs" />
            </Link>
          }
          breadCrumbActive={<IntlMessages id="ui-general-import" />}
        />
      </Row>
      <Row gutter={16}>
        <Col xs={{ span: 24 }} xxl={{ span: 16 }}>
          <Card>
            <Title level={5}>
              <IntlMessages id="dictionaries-import-card-title" />
            </Title>
            <FormImportDictionaries onSubmit={onImportDictionaries} isSubmitting={isImportingDictionaries} />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PageDictionariesImport;
